import script from "./imageZoom.vue?vue&type=script&setup=true&lang=js"
export * from "./imageZoom.vue?vue&type=script&setup=true&lang=js"

import "./imageZoom.vue?vue&type=style&index=0&id=c73ea81a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c73ea81a"]])

export default __exports__